import { render, staticRenderFns } from "./NewsTeaser.vue?vue&type=template&id=014cb310"
import script from "./NewsTeaser.vue?vue&type=script&lang=js"
export * from "./NewsTeaser.vue?vue&type=script&lang=js"
import style0 from "./NewsTeaser.vue?vue&type=style&index=0&id=014cb310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports